const locale = require('./submissionStatus.i18n.json');

/*@ngInject*/
const SubmissionStatusController = function ($scope, submissionConstant, appTypeConfigurationModel, submissionStatus, renewalStatus, submissionReferralStatus, currentSubmissionModel, agentQuoteStatus, submissionUploadStatus) {

    this.i18n = locale;
    this.submission = currentSubmissionModel.getCurrentSubmission();
    this.submissionName = '';
    this.isUnderwriter = appTypeConfigurationModel.isUnderwriterWorkstation();

    this.displayReasonStatus = false;
    this.reason = '';
    this.reasonLabel = '';
    this.renewalStatusReason = '';

    this.displayDetailTooltip = false;
    this.detail = '';
    this.detailLabel = '';
    this.renewalStatusDetail = '';

    this.referral = null;

    this.submission = currentSubmissionModel.getCurrentSubmission();

    this.$onInit = function () {
        if (!_.isNil(this.submission)) {
            this.configureSubmissionStatus();
        }
    };

    this.getStatusLabel = function () {
        let statusCode,
            status,
            statusLabelKey,
            subStatusLabel,
            isUploadStatus = this.submission.uploadStatus === submissionUploadStatus.UPLOAD_IN_PROGRESS || this.submission.uploadStatus === submissionUploadStatus.UPLOAD_PENDING || this.submission.uploadStatus === submissionUploadStatus.UPLOAD_SUCCEEDED;
        if (!_.isNil(this.submission)) {
            statusCode = this.submission.status ? this.submission.status : -1;
            statusLabelKey = this.isUnderwriter ? 'status.' : 'agentStatus.';
            status = _.get(this.i18n, statusLabelKey + statusCode);

            if (this.submission.renewalStatus > 0 || this.submission.cancellationPending || this.submission.endorsementPending) {
                subStatusLabel = this.getSubStatusLabel();
                if (!_.isNil(subStatusLabel)) {
                    status += ' (' + this.getSubStatusLabel() + ')';
                }
            } else if (isUploadStatus && statusCode === submissionStatus.CREATED) {
                status = _.get(this.i18n, statusLabelKey + 'uploadStatus.' + this.submission.uploadStatus);
            }
        }
        return status;
    };

    this.getSubStatusLabel = function () {
        let status = this.submission.status,
            subStatusLabel;
        switch (status) {
            case submissionStatus.BOUND:
            case submissionStatus.PENDING_ISSUANCE:
            case submissionStatus.ISSUED:
            case submissionStatus.EXPIRED:
                if (this.submission.renewalStatus) {
                    switch (this.submission.renewalStatus) {
                        case renewalStatus.RENEWAL_PENDING:
                        case renewalStatus.NON_RENEWAL_PENDING:
                        case renewalStatus.FLAGGED_FOR_NON_RENEWAL:
                            subStatusLabel = _.get(this.i18n, 'renewalStatus.' + this.submission.renewalStatus);
                            if (this.submission.endorsementPending) {
                                subStatusLabel += ', ' + _.get(this.i18n, 'subStatus.endorsementPending');
                            }
                            if (this.submission.cancellationPending) {
                                subStatusLabel += ', ' + _.get(this.i18n, 'subStatus.cancellationPending');
                            }
                            break;
                    }
                } else if (this.submission.endorsementPending && this.submission.cancellationPending) {
                    subStatusLabel = _.get(this.i18n, 'subStatus.endorsementPending') + ', ' + _.get(this.i18n, 'subStatus.cancellationPending');
                } else if (this.submission.cancellationPending) {
                    subStatusLabel = _.get(this.i18n, 'subStatus.cancellationPending');
                } else if (this.submission.endorsementPending) {
                    subStatusLabel = _.get(this.i18n, 'subStatus.endorsementPending');
                }
        }
        return subStatusLabel;
    };

    this.configureSubmissionStatus = function () {
        this.submissionName = _.get(this.submission, 'insured.name');
        this.submissionStatus = this.getStatusLabel();

        this.reason = this.submission.statusReason;
        this.renewalStatusReason = this.submission.renewalStatusReason;
        this.reasonLabel = _.truncate(this.reason || this.renewalStatusReason, {
            'length': 45,
            'separator': ' '
        });
        this.displayReasonStatus = (this.reason || this.renewalStatusReason) !== this.reasonLabel;

        this.detail = this.submission.statusDetail;
        this.renewalStatusDetail = this.submission.renewalStatusDetail;
        this.detailLabel = _.truncate(this.detail || this.renewalStatusDetail, {
            'length': 45,
            'separator': ' '
        });
        this.displayDetailTooltip = this.detailLabel.slice(this.detailLabel.length - 3, this.detailLabel.length) === '...';

        if (submissionReferralStatus.REFER === this.submission.referralStatus) {
            this.referral = _.get(this.submission, 'referredUnderwriterSummary.name');
        } else {
            this.referral = null;
        }
    };

    $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, (event, currentSubmission) => {
        this.submission = currentSubmission;
        if (!_.isNil(this.submission)) {
            this.configureSubmissionStatus();
        }
    });

    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, (event, submission) => {
        if (_.isNil(this.submission) || this.submission.id === submission.id) {
            this.submission = submission;
        }

        if (!_.isNil(this.submission)) {
            this.configureSubmissionStatus();
        }
    });

    this.showReferral = function () {
        let isNotAgentConsole = !appTypeConfigurationModel.isAgentConsole(),
            agentQuotingEnabled = this.submission.agentQuoteStatus === agentQuoteStatus.ENABLED,
            notAgentConsoleOrSTP = isNotAgentConsole || agentQuotingEnabled;

        return !_.isNil(this.referral) && notAgentConsoleOrSTP;
    };
};

angular.module('gw-um-submission')
    .controller('submissionStatusController', SubmissionStatusController);
